import errors from '../../errors';
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { FormActions } from "../abstracts/mixins/FormActions";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";

export default class Incident extends CRUDEntity{

    constructor(id=null) {
        Object.assign(Incident.prototype, HasAttachments);
        Object.assign(Incident.prototype, FormActions);
        Object.assign(Incident.prototype, EntityModalForm);

        super();
        this.entityClass = 'incident';
        this.urlRoot = '/ticket-management/incident';
        this.sectionRootUrl = '/ticket-management';
        this.id = id;
        this.setAttachmentCallbackDelete()

        Incident.prototype.delegatedListnersForButtons = function(type, entityClass) {
            if(type=='create'){
                const userId = $('#app:not(.cockpit-admin) #admin-side-user-info .user_data').data('id')
                $(`#create-incident-modal [name="user_id"] option[value="${userId}"]`).attr('selected','true');
            }
            $(`#${type}-${entityClass} input[name*=id]`).mask("A", {
                translation: {"A": { pattern: /[0-9]/, recursive: true}}
            });
            $(`#${type}-${entityClass} button#${type}`).off('click');
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                const cb = $('.cockpit-main-wrapper').length ? ()=>{
                    $(`#${type}-${entityClass}-modal`).modal('hide')
                    return false;
                } : this.callbackCloseModal;
                const cbError = (response)=>{
                    if(response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors)
                }
                switch(type){
                    case 'create':
                        this.create(cb, cbError);
                        break;
                    case 'edit':
                        this.update(cb, cbError);
                        break;
                }
            });
        }
    }
} 